import React, { useEffect, useState } from "react";
import { publicApi } from "../../lib/api";
import { SITE_PAGE_OPTIONS } from "../../lib/sitePages";

// Dropdown for choosing a link target for an FAQ button.
// Offers the site's main pages plus every live service page (/services/<slug>).
// Preserves any existing non-standard/external value via an ephemeral option.
export default function PageLinkSelect({ value, onChange, className, testId }) {
  const [services, setServices] = useState([]);
  useEffect(() => { publicApi.services().then(setServices).catch(() => setServices([])); }, []);

  const serviceOptions = services
    .filter((s) => s.slug)
    .map((s) => ({ label: s.title || s.slug, value: `/services/${s.slug}` }));

  const known = [...SITE_PAGE_OPTIONS, ...serviceOptions].some((p) => p.value === value);

  return (
    <select data-testid={testId} value={value || ""} onChange={(e) => onChange(e.target.value)} className={className}>
      <option value="">No link</option>
      <optgroup label="Main pages">
        {SITE_PAGE_OPTIONS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
      </optgroup>
      {serviceOptions.length > 0 && (
        <optgroup label="Service pages">
          {serviceOptions.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
        </optgroup>
      )}
      {value && !known && <option value={value}>{value}</option>}
    </select>
  );
}
